import React, { Component } from "react";
import { Link } from "react-router-dom";

class Logo extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const oroLogo = (
      <img src={process.env.REACT_APP_IMAGES_PATH + "biddeasy.webp"} className={`logo ${this.props.className}`} alt="logo" />
    );
    return oroLogo;
  }
}

export default Logo;
